import creditCardLogo from '../assests/credit-cards.png';

export function PaymentOptions(){
  return (
    <>
      <p>We accept cash and all major credit cards</p>
      <img src={creditCardLogo} style={{ maxWidth: '200px' }} alt="Visa, Mastercard, Discover, AMEX" />
    </>
  )
}